import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

// function srcset(image: string, size: number, rows = 1, cols = 1) {
//   return {
//     src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
//     srcSet: `${image}?w=${size * cols}&h=${
//       size * rows
//     }&fit=crop&auto=format&dpr=2 2x`,
//   };
// }

export default function Gallery() {
  return (
    <ImageList
      gap={20}
      // sx={{ width: 'full'}}
      // variant="quilted"
      cols={3}
      // rowHeight={121}
    >
      {itemData.map((item) => (
        <ImageListItem key={item.img}>
          <img
            src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
            srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
            alt={item.title}
            loading="lazy"
            onClick={() => window.open(item.img)}
            style={{cursor: "pointer"}}
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}

const itemData = [
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1698613875/HomeBaseGallery/jtfmcabggjh8wmgncxbx.jpg',
    title: 'Award',
    
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1681431412/HomeBaseGallery/340188819_1274451303179857_3000747488336915868_n_lucuix.jpg',
    title: 'earrings',
   
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1681431410/HomeBaseGallery/others_bnso2i.jpg',
    title: 'Others',
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1681431409/HomeBaseGallery/339688334_782673286320445_1008374817666198416_n_uheeen.jpg',
    title: 'Earings',
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1681431408/HomeBaseGallery/brooches_nh71u8.jpg',
    title: 'Coffee',
   
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1681431408/HomeBaseGallery/337652091_738352651130008_2753028256048963036_n_hvc7s0.jpg',
    title: 'Hats',
    
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1681431404/HomeBaseGallery/brooch_qhtzmj.jpg',
    title: 'Honey',
    author: '@arwinneil',
  
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1681431403/HomeBaseGallery/328863318_495466316123966_4876058982627183072_n_iitkcp.jpg',
    title: 'Basketball',
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1681431403/HomeBaseGallery/328348112_745835786938862_2123536566577391534_n_wegrkx.jpg',
    title: 'Fern',
  },
  
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1681431400/HomeBaseGallery/260854570_124099890066026_8889826841496649055_n_ejcxep.jpg',
    title: 'Tomato basil',
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1698613523/HomeBaseGallery/aqkuum8wqxkjue4j2xdg.jpg',
    title: 'Sea star',
  },
  {
    img: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1696380011/HomeBaseGallery/gn0rjjz4w04dg9lnqg79.jpg',
    title: 'Brooch',
    
  },
];